
































































import { Component, Vue, Prop } from 'vue-property-decorator';

/** 随机id生成 */
const uid = () => Math.random().toString(36)
  .substring(2);
/** rem转化成px */
const remToPx = (x: number) => x / 100 * parseFloat(document.documentElement.style.fontSize);

@Component
export default class ContentLoader extends Vue {
  @Prop({ default: '' }) viewBox!: string;
  @Prop({ default: 'xMidYMid meet' }) preserveAspectRatio!: string;
  @Prop({ default: 2 }) speed!: number;
  @Prop({ default: '' }) baseUrl!: string;
  @Prop({ default: '#f9f9f9' }) primaryColor!: string;
  @Prop({ default: '#ecebeb' }) secondaryColor!: string;
  @Prop({ default: 1 }) primaryOpacity!: number;
  @Prop({ default: 1 }) secondaryOpacity!: number;
  @Prop({ default: '' }) uniqueKey!: string;
  @Prop({ default: true }) animate!: boolean;
  get idClip() {
    return this.uniqueKey ? `${this.uniqueKey}-idClip` : uid();
  }
  get idGradient() {
    return this.uniqueKey ? `${this.uniqueKey}-idGradient` : uid();
  }
  get width() {
    const viewBoxWidth = +this.viewBox.split(' ')[2];
    return remToPx(viewBoxWidth);
  }
  get height() {
    const viewBoxHeight = +this.viewBox.split(' ')[3];
    return remToPx(viewBoxHeight);
  }
}
